const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const getApiBase = () => API_BASE;

export const getAuthToken = () => localStorage.getItem('murjan_token');

export const buildHeaders = (headers = {}, includeAuth = true) => {
  const nextHeaders = { ...headers };
  if (includeAuth) {
    const token = getAuthToken();
    if (token) {
      nextHeaders.Authorization = `Bearer ${token}`;
    }
  }
  return nextHeaders;
};

export const apiFetch = async (path, options = {}) => {
  const { headers, includeAuth = true, ...rest } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    ...rest,
    headers: buildHeaders(headers, includeAuth),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const detail = data?.detail || data?.message || 'Request failed';
    throw new Error(detail);
  }

  return data;
};
